import { render, staticRenderFns } from "./order_cancel_modal.vue?vue&type=template&id=1b4d152c&scoped=true"
import script from "./order_cancel_modal.vue?vue&type=script&lang=js"
export * from "./order_cancel_modal.vue?vue&type=script&lang=js"
import style0 from "./order_cancel_modal.vue?vue&type=style&index=0&id=1b4d152c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d152c",
  null
  
)

export default component.exports